// extracted by mini-css-extract-plugin
export default {"richTextOutput":"styles_rich-text-output_eYpS_"};